<script>
import Logo from './Logo.vue';
import PrimaryNavItem from './PrimaryNavItem.vue';
import NotificationBell from './NotificationBell.vue';

export default {
  components: {
    Logo,
    PrimaryNavItem,
    NotificationBell,
  },
  props: {
    logoThumbnail: { type: String, required: true },
    logoThumbnailDark: { type: String, required: true },
    installationName: { type: String, default: '' },
    accountId: { type: Number, default: 0 },
    menuItems: { type: Array, default: () => [] },
    activeMenuItem: { type: String, default: '' },
    internalChatUnreadCount: { type: Number, default: 0 },
  },
  methods: {
    openNotificationPanel() {
      this.$emit('openNotificationPanel');
    },
    primaryNavBadge(menuItem) {
      if (menuItem.key !== 'internal_chat') return '';
      const n = this.internalChatUnreadCount;
      if (!n || n < 1) return '';
      return n > 99 ? '99+' : String(n);
    },
  },
};
</script>

<template>
  <div
    class="flex h-full min-h-0 w-14 shrink-0 flex-col overflow-y-auto border-r border-slate-50 bg-white dark:border-slate-800/50 dark:bg-slate-900 md:w-[92px] rtl:border-l rtl:border-r-0"
  >
    <div class="flex min-h-full flex-col items-center pb-4 md:pb-6">
      <Logo
        :logo-thumbnail="logoThumbnail"
        :logo-thumbnail-dark="logoThumbnailDark"
        :name="installationName"
        :account-id="accountId"
      />
      <PrimaryNavItem
        v-for="menuItem in menuItems"
        :key="menuItem.toState"
        :icon="menuItem.icon"
        :name="menuItem.label"
        :to="menuItem.toState"
        :count="primaryNavBadge(menuItem)"
        :is-child-menu-active="menuItem.key === activeMenuItem"
      />
      <div class="mt-auto flex flex-col items-center">
        <NotificationBell @open-notification-panel="openNotificationPanel" />
      </div>
    </div>
  </div>
</template>
